import { IMAGES, SOCIAL } from "../../data/content";

export const ClubVillage = () => (
  <section
    id="capitolo-3"
    data-testid="club-village-section"
    className="py-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 border-b border-neutral-800"
  >
    <div className="mb-12">
      <h2 className="font-display text-3xl sm:text-4xl font-black uppercase text-white">
        Club Storiche & Legend Village
      </h2>
      <p className="text-sm text-neutral-400 mt-1">
        Due anime complementari: tradizione motoristica e villaggio outdoor a Perticara.
      </p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      <div
        data-testid="club-storiche-card"
        className="bg-neutral-900/60 border border-neutral-800 border-l-4 border-l-red-600"
      >
        <img
          src={IMAGES.clubStoriche}
          alt="Raduno Legend Team Club Storiche: auto d'epoca sui tornanti verso Sant'Agata Feltria e la Miniera di Perticara"
          className="w-full aspect-[16/9] object-cover border-b border-neutral-800"
        />
        <div className="p-8">
          <h3 className="font-display text-2xl font-black uppercase text-white mb-3">
            Club Auto & Moto Storiche
          </h3>
          <p className="text-sm text-neutral-300 leading-relaxed mb-6">
            Società convenzionata per tutti i possessori di auto e moto d'epoca.
            Gestiamo polizze assicurative agevolate, raduni calendarizzati,
            consulenze tecniche ed eventi per collezionisti.
          </p>
          <ul className="text-xs uppercase tracking-wider text-neutral-400 space-y-2 mb-6">
            <li>&bull; Assicurazioni storiche agevolate</li>
            <li>&bull; Raduni ed eventi dedicati</li>
            <li>&bull; Assistenza per pratiche club</li>
          </ul>
          <a
            data-testid="club-cta"
            href="#contact"
            className="inline-block text-xs uppercase tracking-widest font-bold text-red-500 hover:text-red-400"
          >
            Iscriviti al Club &rarr;
          </a>
        </div>
      </div>

      <div
        data-testid="legend-village-card"
        className="bg-neutral-900/60 border border-neutral-800 border-l-4 border-l-neutral-700"
      >
        <div className="aspect-[16/9] border-b border-neutral-800 bg-black">
          <iframe
            data-testid="village-video"
            title="Legend Village a Perticara — il villaggio in costruzione"
            src={`https://www.youtube-nocookie.com/embed/${SOCIAL.villageVideoId}?rel=0`}
            className="w-full h-full"
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </div>
        <div className="p-8">
          <div className="inline-block mono-label text-xs bg-red-950 text-red-400 px-2 py-0.5 mb-2">
            In Costruzione &bull; guarda il video del cantiere
          </div>
          <h3 className="font-display text-2xl font-black uppercase text-white mb-3">
            Legend Village a Perticara
          </h3>
          <p className="text-sm text-neutral-300 leading-relaxed mb-6">
            Villaggio dello sport nei boschi della Miniera di Perticara nel comune
            di Sant'Agata Feltria. Pub accogliente, percorsi e noleggio bici
            elettriche, palestra all'aperto, alloggi e zona camper/tende. Un luogo
            in cui la comunità Legend possa riconoscersi e incontrarsi, accanto alla
            nascente testata Legend Magazine.
          </p>
          <ul className="text-xs uppercase tracking-wider text-neutral-400 space-y-2 mb-6">
            <li>&bull; Pub e punto ristoro</li>
            <li>&bull; Percorsi e-bike nei boschi</li>
            <li>&bull; Palestra all'aperto e area camper</li>
          </ul>
          <a
            data-testid="village-cta"
            href="#contact"
            className="inline-block text-xs uppercase tracking-widest font-bold text-red-500 hover:text-red-400"
          >
            Dettagli sul Village &rarr;
          </a>
        </div>
      </div>
    </div>
  </section>
);
